import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyFormat } from '../currencyFormat.pipe';



@NgModule({
  declarations: [CurrencyFormat],
  imports: [
    CommonModule
  ],
  exports: [CurrencyFormat]
})
export class CurrencyFormatModule { }
